module.exports = __webpack_public_path__ + "static/img/scene_pic1.6791df2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/scene_pic1.png
// module id = Gbfq
// module chunks = 1